import { createReducer } from '@reduxjs/toolkit'
import { getScenarioPlannerOptionsSuccess } from '../actions/reportingService'

const initialState = {}

export const scenarioPlannerOptions = createReducer(initialState, {
  [getScenarioPlannerOptionsSuccess.type]: (state, action) => action.payload
})
